export default "__VITE_ASSET__Dtwx0Wf1__"